class AdminResponseOrgTypeCompleteModel {
    constructor({
                    type = '',
                    permissions = [],
                    costBearerNames = [],
                } = {}) {
        this.type = type;
        this.permissions = permissions;
        this.costBearerNames = costBearerNames;
    }

    static getAttributes(filter = null, validationSchema = null, optionsData = null) {
        const attributes = {
            type :{
                'label': 'Type',
                'sortable': true,
                'sortField': "type",
                'value': (item) => item.type || "",
            },
            permissions :{
                'label': 'Permissions',
                'sortable': true,
                'sortField': "permissions",
                'value': (item) => item.permissions || "",
            },
            costBearerNames :{
                'label': 'Cost Bearer Names',
                'sortable': true,
                'sortField': "costBearerNames",
                'value': (item) => item.costBearerNames || "",
            },

        }

        return attributes;
    }
}

export default AdminResponseOrgTypeCompleteModel;